import React, { Component } from "react";

// const htmlContent = `<!DOCTYPE html>
// <html lang="en">

// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <meta http-equiv="X-UA-Compatible" content="ie=edge">
//     <title>Flappy Bird</title>
//     <link rel="stylesheet" href="style/style.css">
// </head>

// <body>
//      <div>ASd</div>
//     <script src="https://cdnjs.cloudflare.com/ajax/libs/p5.js/0.7.1/p5.min.js"></script>
//     <script src="https://cdnjs.cloudflare.com/ajax/libs/p5.js/0.7.1/addons/p5.dom.min.js"></script>
//     <script src="https://cdnjs.cloudflare.com/ajax/libs/p5.js/0.7.1/addons/p5.sound.min.js"></script>
//     <script src="./gameLogic/main.js"></script>
// </body>

// </html>`;

// const html = require("./index.html");
// const template = { __html: htmlContent };

// const html = require("./index.html");

class FlappyBird extends Component {
  constructor(props) {
    super(props);
    console.log("rendered!");
  }

  render() {
    return <></>;
    // return <iframe src={html} />;
  }
}

export default FlappyBird;
